import { Box, Container, IconButton, Menu, MenuItem, useMediaQuery } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/brand.png';
import { DEVICES } from '../const';
import MenuIcon from '@mui/icons-material/Menu';


const MENU_OPTIONS = [
  {
    name: 'Home',
    link: '/',
  },
  {
    name: 'About',
    link: '/about',
  },
  // {
  //   name: 'Program',
  //   link: '/program',
  // },
  // {
  //   name: 'Sneak Peek',
  //   link: '/sneak_peek',
  // },
];

const StyledLink = styled(Link)`
  font-weight: 700;
  text-decoration: none;
  color: #112347;
  &:hover {
    color: #ffc706;
  }
  @media ${DEVICES.mobile} {
    margin: 0 1rem;
  }
  @media ${DEVICES.tablet} {
    margin: 0 1rem;
  }
  @media ${DEVICES.laptop} {
    margin: 0 1.5rem;
  }
`;

const NavBarContainer = styled.div`
  width: 100%;
  display: fixed;
  box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 24%) inset;
  @media ${DEVICES.mobile} {
    height: 56px;
  }

  @media ${DEVICES.tablet} {
    height: 80px;
  }
`;

const LogoImg = styled.img`
  cursor: pointer;
  @media ${DEVICES.mobile} {
    height: 32px;
    width: 128px;
  }

  @media ${DEVICES.tablet} {
    height: 48px;
    width: 204px;
  }
`;

// const NavBarContainer = styled.div<{ scrollY: number }>(({ scrollY }) => {
//   return scrollY > 0 ? {
//     display: 'fixed',
//     height: '80px',
//     width: '100%',
//     opacity: '1',
//     transform: 'translate3d(0, 0, 0)',
//     transition: 'transform 0.2s linear, opacity 0.2s linear',
//     boxShadow: '0px 0px 2px 0px rgb(0 0 0 / 24%) inset',
//   } : {
//     display: 'block',
//     height: '80px',
//     width: '100%',
//     boxShadow: '0px 0px 2px 0px rgb(0 0 0 / 24%) inset',
//   }
// });

export default function MainHeader() {

  const [scrollY, setScrollY] = useState<number>(0);
  const [menuButtonEl, setMenuButtonEl] = useState<null | HTMLElement>(null);
  const showMenu = useMemo(() => menuButtonEl !== null, [menuButtonEl]);
  const navigate = useNavigate();
  const tabletMode = useMediaQuery(DEVICES.tablet);
  const handleScroll = useCallback(() => {
    setScrollY(window.scrollY);
  }, []);

  useEffect(() => {
    if (typeof window !== undefined) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  const getNavBar = () => {
    if (tabletMode) {
      return <Box sx={{ display: 'flex' }}>
        {MENU_OPTIONS.map(option => {
          return <StyledLink key={option.name} to={option.link}>{option.name}</StyledLink>
        })}
      </Box>
    } else {
      return <div>
        <IconButton
          aria-label='more'
          id='menu-button'
          aria-controls={showMenu ? 'menu' : undefined}
          // aria-expanded={showMenu ? 'true' : undefined}
          aria-haspopup='true'
          onClick={(event) => setMenuButtonEl(event.currentTarget)}>
          <MenuIcon />
        </IconButton>
        <Menu
          id="menu"
          MenuListProps={{
            'aria-labelledby': 'menu-button',
          }}
          open={showMenu}
          onClose={() => setMenuButtonEl(null)}
          anchorEl={menuButtonEl}
        >
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.name} onClick={() => navigate(option.link)}>
              {option.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    }
  }

  return <NavBarContainer>
    <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
      <Box sx={{ display: 'flex', width: '200px', alignItems: 'center' }}>
        <Box sx={{ marginRight: '1rem' }}>
          <LogoImg src={logo} onClick={() => navigate('/')} />
        </Box>
      </Box>
      {getNavBar()}
    </Container>
  </NavBarContainer >
}
